<template>
  <div>
    <div v-if="!isComponente">
      <top-bar title="Meus dados" :link="editarTelefone"/>
    </div>
    <loading v-show="loadDados" :fullscrean="true" text="Carregando os dados"/>
    <div class="mx-auto" :class="{ 'p-bottom': !isComponente }" style="max-width: 400px" v-show="!loadDados">
      <div class="container-fluid">
        <div v-if="!editar">
          <div class="mb-2" v-show="step >= 3">
            <p class="mb-0" v-if="step === 3">Para continuar, por favor informe seus dados.</p>
            <p class="mb-0" v-if="step === 4">{{usuario.nome_cliente}}</p>
            <div class="small">
              <span class="mr-1" v-if="tipoLogin === 3">{{usuario.cpf | cpf}}</span>
              <span class="mr-1" v-else>{{usuario.email | maskPhone}}</span>
              <a href="javascript:" class="text-info" @click="toggleMenu()">(Alterar)</a>
            </div>
          </div>
        </div>
        <div v-show="step < 3">
          <form @submit.prevent="validate">
            <div class="form-group mb-2" v-if="step === 1">
              <modal-menu :menus="menus" :selected="tipoLogin" left="true" @changeMenu="toggleTipoLogin" class="mb-3"/>
              <div v-if="tipoLogin === 1">
                <label class="mb-0 font-weight-bold small">Telefone *</label>
                <the-mask id="telefoneLogin" :mask="['(##) ####-####', '(##) #####-####']" class="form-control" type="tel" v-model="usuario.email" placeholder="(##) #####-####" required/>
              </div>
              <div v-if="tipoLogin === 2">
                <label class="mb-0 font-weight-bold small">E-mail *</label>
                <input type="text" id="email" class="form-control text-lowercase" placeholder="Seu endereço de email" v-model="usuario.email" maxlength="100" required>
              </div>
              <div v-if="tipoLogin === 3">
                <label class="mb-0 font-weight-bold small">CPF *</label>
                <the-mask id="cpfLogin" :mask="['###.###.###-##']" class="form-control" type="tel" v-model="usuario.email" placeholder="###.###.###-##" required/>
              </div>
            </div>
            <div class="form-group mb-2" v-if="step === 2">
              <div class="mb-2">
                <p class="mb-0">Cliente já cadastrado.</p>
                <div class="small">
                  <span v-if="tipoLogin === 3">{{usuario.email | cpf}}</span>
                  <span v-else>{{usuario.email | maskPhone}}</span>
                  <a href="javascript:" class="text-info ml-1" @click="toggleMenu()">(Alterar)</a>
                </div>
              </div>
              <div class="mt-3" v-if="users">
                <div class="card card-user">
                  <h6 class="text-center small font-weight-bold" style="margin-bottom: 12px">Selecione uma conta</h6>
                  <div class="border-top" v-if="load">
                    <loading/>
                  </div>
                  <div v-else>
                    <a class="user text-dark text-decoration-none" href="javascript:" v-for="u in users" @click="selConta(u)">
                      <div>
                        <div>{{u.telefone | maskPhone}}</div>
                        <div class="font-weight-bold small">{{u.nome_cliente || 'Sem nome'}}</div>
                        <div class="small">Último pedido: {{u.ultimo_pedido || 'Não há pedidos' }}</div>
                        <div class="small" v-if="isNaN(u.email) && u.tipo_cliente === '1'">{{u.email}}</div>
                        <div class="small" v-else>Cadastrado via {{u.tipo_cliente | tipo_cliente }}</div>
                      </div>
                      <i class="fa fa-angle-right ml-auto mr-2"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div v-else>
                <label class="mb-0 font-weight-bold small">Senha*</label>
                <div class="input-senha">
                  <input type="password" class="form-control" id="senha" placeholder="Informe sua senha" v-model="usuario.senha" maxlength="100" required>
                  <i class="fa fa-eye" @click="mostrarSenha('senha')" v-show="usuario.senha.length > 0"></i>
                </div>
              </div>
            </div>
            <div v-if="!users">
              <button class="btn btn-primary btn-block" :disabled="load">
                <span v-show="load"><i class="fa fa-spinner fa-pulse"></i> Aguarde</span>
                <span v-show="!load">{{ step === 2 ? 'Entrar' : 'Próximo' }}</span>
              </button>
            </div>
          </form>
          <div class="text-center my-3" v-if="step === 2 && !users">
            Esqueceu sua senha? <a href="javascript:" class="text-info" @click="recuperarSenha">Recuperar</a>
          </div>
        </div>

        <div class="mb-2" v-if="step === 1">
          <login-facebook str="Entrar com Facebook" hr="true"/>
        </div>

        <div v-if="step === 3">
          <form @submit.prevent="validate">
            <p class="mb-2" v-if="editarTelefone">
              Para realizar o pedido você deve informar um celular/telefone de contato.
            </p>
            <div class="form-group mb-2" v-if="usuario.tipo_cliente === '1'">
              <label class="mb-0 font-weight-bold small">Telefone com DDD *</label>
              <the-mask id="telefoneCliente" :mask="['(##) ####-####', '(##) #####-####']" class="form-control" type="tel" v-model="usuario.telefone" placeholder="(##) #####-####"
                        :disabled="tipoLogin === 1 && !editar" required/>
            </div>
            <div class="form-group mb-2" v-else-if="usuario.telefone">
              <label class="mb-0 font-weight-bold small">Telefone</label>
              <div class="form-control" style="background-color: #e9ecef">{{usuario.telefone | maskPhone}}</div>
            </div>
            <div v-show="!editarTelefone">
              <div class="form-group mb-2">
                <label class="mb-0 font-weight-bold small">Nome *</label>
                <input id="nomeCliente" type="text" class="form-control" placeholder="Seu nome completo" v-model="usuario.nome_cliente" maxlength="100" required
                      :disabled="bloquear_nome" style="text-transform: capitalize">
              </div>
              <div class="form-group mb-2" v-if="isEmail && usuario.tipo_cliente === '1'">
                <label class="mb-0 font-weight-bold small">Email {{ isEmail ? '*' : '' }}</label>
                <input type="email" autocomplete="email" class="form-control" placeholder="Seu endereço de email" v-model="usuario.email" maxlength="100" :required="isEmail"
                :disabled="tipoLogin === 2 && !editar">
              </div>
              <div class="form-group mb-2" v-if="editar || cpf_pedido">
                <label class="mb-0 font-weight-bold small">
                  CPF {{ cpf_pedido ? '*' : '' }}
                  <a href="javascript:" class="text-info" @click="alterarCpf" v-if="cpf_mascarado && !bloquear_nome">(Alterar)</a>
                </label>
                <input type="text" class="form-control" :value="cpf_mascarado" disabled v-if="cpf_mascarado">
                <the-mask id="cpf" type="tel" :mask="['###.###.###-##']" class="form-control" v-model="usuario.cpf" placeholder="###.###.###-##"
                          :required="cpf_pedido" :disabled="tipoLogin === 3 && !editar" v-else/>
              </div>
              <div v-if="editar || cadastro_completo">
                <div class="form-group mb-2">
                  <label class="mb-0 font-weight-bold small">
                    Data de nascimento {{ cadastro_completo ? '*' : '' }}
                  </label>
                  <the-mask id="nascimento" type="tel" :mask="['##/##/####']" class="form-control" v-model="data_nascimento" placeholder="##/##/####" :required="cadastro_completo"/>
                </div>
                <div class="form-group mb-2">
                  <label class="mb-0 font-weight-bold small">
                    Gênero {{ cadastro_completo ? '*' : '' }}
                  </label>
                  <select id="genero" class="form-control" v-model="usuario.genero" :required="cadastro_completo">
                    <option :value="null">Selecione</option>
                    <option value="1">Masculino</option>
                    <option value="2">Feminino</option>
                    <option value="3">Outro</option>
                  </select>
                </div>
              </div>

              <div class="card mt-3" v-if="editar && login_senha">
                <div class="card-body">
                  <div class="form-group form-check mb-1" v-if="!usuario.sem_senha">
                    <input type="checkbox" class="form-check-input" id="editarSenha" v-model="trocarSenha" maxlength="100">
                    <label class="form-check-label" for="editarSenha">{{ usuario.sem_senha ? 'Cadastrar senha' : 'Trocar senha' }}</label>
                  </div>
                  <div class="mb-1" v-else>
                    <h6 class="mb-1 font-weight-bold tamanho-1">Deseja cadastrar uma senha?</h6>
                    <div class="small">Ela será usada para garantir que só você terá acesso a suas informações e benefícios.</div>
                  </div>
                  <div class="form-group mb-2">
                    <label class="mb-0 font-weight-bold small">Senha</label>
                    <div class="input-senha">
                      <input type="password" id="novaSenhaCad" autocomplete="new-password" class="form-control" placeholder="Sua senha (mínimo 6 dígitos)" minlength="6" maxlength="100" v-model="senha" :required="trocarSenha" :disabled="!trocarSenha && !usuario.sem_senha">
                      <i class="fa fa-eye" @click="mostrarSenha('novaSenhaCad')" v-show="senha.length > 0"></i>
                    </div>
                  </div>
                  <div class="form-group mb-0">
                    <label class="mb-0 font-weight-bold small">Confirmar senha</label>
                    <div class="input-senha">
                      <input type="password" id="repeteSenhaCad" autocomplete="new-password" class="form-control" placeholder="Sua senha novamente" minlength="6" maxlength="100" v-model=senhaConfirmacao :required="trocarSenha" :disabled="!trocarSenha && !usuario.sem_senha">
                      <i class="fa fa-eye" @click="mostrarSenha('repeteSenhaCad')" v-show="senhaConfirmacao.length > 0"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <button class="btn btn-primary btn-block mt-3" :disabled="load">
              <span v-show="load"><i class="fa fa-spinner fa-pulse"></i> Aguarde</span>
              <span v-show="!load">{{editar ? 'Salvar' : 'Confirmar'}}</span>
            </button>
          </form>

          <div class="mt-4 mb-3 text-muted" v-if="step >= 3">
            <hr>
            <div class="mb-2" v-if="usuario.id_cliente">
              <div class="small">* Campos obrigatórios</div>
              <div class="small">ID: LE0{{ usuario.id_cliente }}</div>
            </div>
            <div class="small">Concordo com os <a href="https://lecard.delivery/termos-de-uso/" target="_blank" class="text-primary font-weight-bold">Termos e Condições de uso</a>.</div>
            <div class="small">Estou enviando informações verdadeiras podendo responder civilmente perante a lei.</div>
          </div>
        </div>

        <div v-if="step === 4">
          <form @submit.prevent="validate">
            <div class="card mb-3">
              <div class="card-body">
                <div class="mb-2">
                  <div class="d-flex justify-content-between align-items-center mb-1">
                    <h6 class="mb-0 font-weight-bold tamanho-1">Cadastrar senha</h6>
                    <span class="badge badge-primary float-right">Opcional</span>
                  </div>
                  <div class="small">Ela será usada para garantir que só você terá acesso a suas informações e benefícios.</div>
                </div>
                <div class="form-group mb-2">
                  <label class="mb-0 font-weight-bold small">Senha</label>
                  <div class="input-senha">
                    <input type="password" id="novaSenha" autocomplete="new-password" class="form-control" placeholder="Sua senha (mínimo 6 dígitos)" minlength="6" maxlength="100" v-model="senha" required>
                    <i class="fa fa-eye" @click="mostrarSenha('novaSenha')" v-show="senha.length > 0"></i>
                  </div>
                </div>
                <div class="form-group mb-3">
                  <label class="mb-0 font-weight-bold small">Confirmar senha</label>
                  <div class="input-senha">
                    <input type="password" id="repeteSenha" autocomplete="new-password" class="form-control" placeholder="Sua senha novamente" minlength="6" maxlength="100" v-model=senhaConfirmacao required>
                    <i class="fa fa-eye" @click="mostrarSenha('repeteSenha')" v-show="senhaConfirmacao.length > 0"></i>
                  </div>
                </div>
                <button class="btn btn-primary btn-block" :disabled="load">
                  <span v-if="load === true"><i class="fa fa-spinner fa-pulse"></i> Aguarde</span>
                  <span v-else>Confirmar</span>
                </button>
              </div>
            </div>
          </form>

          <button class="btn btn-outline-primary btn-block" :disabled="load" @click="cadastrarSemSenha()">
            <span v-if="load === 1"><i class="fa fa-spinner fa-pulse"></i> Aguarde</span>
            <span v-else>Continuar sem senha</span>
          </button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import {TheMask} from 'vue-the-mask';
  import LoginFacebook from '../components/auth/LoginFacebook';
  import Loading from "../components/Loading";
  import ModalMenu from "../components/ModalMenu";
  import TopBar from "../components/TopBar";

  export default {
    name: 'PerfilCadastro',
    components: {TopBar, ModalMenu, Loading, TheMask, LoginFacebook},
    props: ['isComponente'],
    data() {
      return {
        token: localStorage.getItem('token'),
        senhaConfirmacao: '',
        editar: false,
        trocarSenha: false,
        senha: '',
        aceitarTermos: false,
        load: false,
        loadDados: false,
        url: '',
        users: null,
        step: 1,

        tipoLogin: 1,
        menus: [
          { nome: 'Telefone', active: true },
          { nome: 'E-mail', active: true },
          { nome: 'CPF', active: true },
        ],

        editarTelefone: true,
        isEmail: false,
        cpf_mascarado: '',
        data_nascimento: '',

        cadastro_completo: false,
        cpf_pedido: false,
        bloquear_nome: false,
        login_senha: false,

        usuario:  {
          nome_cliente: '',
          telefone: '',
          email: '',
          senha: '',
          tipo_cliente: '1',
          cpf: '',
          data_nascimento: '',
          genero: null,
          sem_senha: true
        },
      }
    },

    methods: {
      buscarUsuario(callback) {
        this.loadDados = true;
        this.$http.get(this.$store.state.base_url + this.token + '/cliente')
          .then(response => {
            this.loadDados = false;
            const dados = response.data && response.data.id_cliente ? response.data : null;

            if (!dados) {
              this.$swal("Erro ao buscar os dados do cliente");
              return;
            }

            dados.telefone = dados.telefone || "";
            this.$store.state.dataUser = dados;
            this.usuario = JSON.parse(JSON.stringify(dados));
            this.isEmail = isNaN(this.usuario.email);

            if (this.usuario.cpf && this.usuario.cpf.length === 11) {
              this.cpf_mascarado = `${this.usuario.cpf.slice(0, 3)}.***.***-${this.usuario.cpf.slice(9, 11)}`;
            }

            if (!this.isEmail) {
              this.usuario.email = "";
            }

            if (this.usuario.data_nascimento) {
              const data = this.usuario.data_nascimento;
              this.data_nascimento = `${data.substring(8, 10)}${data.substring(5, 7)}${data.substring(0, 4)}`;
            }

            if (callback) {
              callback();
            }

          }, res => {
            this.loadDados = false;
            if (res.status === 401 && res.data.result !== '') {
              this.$store.commit('logout');
              this.$router.push(this.url + '/perfil');
              this.$swal(res.data.result + ' ' + res.data.msg);
            }
          });
      },

      login() {
        this.isEmail = isNaN(this.usuario.email);

        if (this.step === 3) {
          this.editarOrCadastrarCliente();

        } else {
          this.load = true;
          this.usuario.tipo_login = this.tipoLogin;

          this.$http.post(this.$store.state.base_url + 'login', this.usuario)
            .then(res => {
              const data = res && res.data ? res.data : {};

              if (data.success && data.token) {
                this.$emit('registrarLogin', res);

              } else if (data.success) {
                this.step = 2;
                this.usuario.email = data.email || this.usuario.email;
                this.users = data.users || null;
                this.$nextTick(() => {
                  this.$helpers.focusrElement('senha');
                });

              } else {
                this.novaConta();
              }

              this.load = false;

            }, res => {
              this.load = false;
              this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
            });
        }
      },

      validate() {
        this.load = true;

        if (this.step === 1) {
          if (this.tipoLogin === 3) {
            if (!this.$helpers.validarCpf(this.usuario.email)){
              this.load = false;
              this.$swal("Por favor informe um CPF válido").then(() => {
                this.$helpers.focusrElement("cpfLogin");
              });

              return;
            }

          } else {
            const regex = new RegExp('^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})|(^[0-9]{10})+$');

            if (this.usuario.email.trim() && !isNaN(this.usuario.email)) {
              if (this.usuario.email.length < 10 || this.usuario.email.length > 11) {
                this.load = false;
                this.$swal('Por favor, informe um telefone no formato válido (DDD + Número)').then(() => {
                  this.toggleTipoLogin(2);
                });

                return;
              }

            } else if (!regex.test(this.usuario.email)) {
              this.$swal('Por favor, informe um e-mail ou telefone válido');
              this.load = false;
              return;
            }
          }

        } else if (this.step === 3) {
          if (this.senha && (this.senha !== this.senhaConfirmacao)) {
            this.$swal("As senhas não correspondem.");
            this.load = false;
            return;
          }

          if (this.usuario.telefone.length < 10) {
            this.$swal("Informe um telefone válido! É a partir dele que entraremos em contato para confirmaçâo de pedidos.");
            this.load = false;
            return;
          }

          if ((this.usuario.cpf || this.cpf_pedido) && !this.$helpers.validarCpf(this.usuario.cpf)) {
            this.load = false;
            const msg = this.cpf_pedido ? "Por favor informe um CPF válido" : "Por favor informe um CPF válido ou remova o CPF";
            this.$swal(msg).then(() => {
              this.$helpers.focusrElement("cpf")
            });
            return;
          }

          if ((this.data_nascimento || this.cadastro_completo)) {
            const data_nascimento = this.$helpers.validarAniversario(this.data_nascimento);

            if (!data_nascimento) {
              this.load = false;
              const msg = this.cadastro_completo ? "Por favor informe uma data de nascimento válida no formato: dd/mm/aaaa" : "Por favor informe uma data de nascimento válida no formato dd/mm/aaaa ou remova a data";
              this.$swal(msg).then(() => { this.$helpers.focusrElement("nascimento")});
              return;
            }

            this.usuario.data_nascimento = data_nascimento;
          }

          if (this.cadastro_completo && !this.usuario.genero) {
            this.load = false;
            this.$swal("Por favor informe o genero que você se identifica").then(() => {
              this.$helpers.focusrElement("genero")
            });
            return;
          }

          if (!this.editar && this.login_senha) {
            setTimeout(() => {
              this.load = false;
              this.step = 4;
            }, 600);

          } else {
            this.editarOrCadastrarCliente();
          }

          return;

        } else if (this.step === 4) {
          if (this.senha && (this.senha !== this.senhaConfirmacao)) {
            this.$swal("As senhas não correspondem.");
            this.load = false;
            return;
          }

          this.editarOrCadastrarCliente();
          return;
        }

        this.login();
      },

      cadastrarSemSenha() {
        if (this.senha.length > 0) {
          this.$swal("Para continuar com o cadastro sem senha, por favor remova as senhas informadas.").then(() => {
            this.$helpers.focusrElement('novaSenha');
          });

          return;
        }

        this.senhaConfirmacao = '';
        this.usuario.senha = '';
        this.load = 1;
        this.editarOrCadastrarCliente();
      },

      toggleTipoLogin(m) {
        this.tipoLogin = m;
        this.usuario.telefone = '';
        this.usuario.email = '';

        this.$nextTick(() => {
          this.$helpers.focusrElement(this.tipoLogin === 2 ? 'email' : (this.tipoLogin === 3 ? 'cpfLogin' : 'telefoneLogin'));
        });
      },

      toggleMenu() {
        this.step = 1;
        this.users = null;
        this.senha = '';
        this.senhaConfirmacao = '';
        this.usuario.senha = "";
        this.usuario.id_cliente = null;
        this.usuario.nome_cliente = '';
        this.usuario.cpf = '';
        this.toggleTipoLogin(this.tipoLogin);
      },

      selConta(user) {
        this.usuario.id_cliente = user.id_cliente;
        this.$nextTick(() => {
          if (user.sem_senha) {
            this.login();

          } else {
            this.users = null;
            this.$helpers.focusrElement('senha');
          }
        });
      },

      editarOrCadastrarCliente() {
        let url = this.$helpers.base_url(this, this.empresa);

        if (this.editar) {
          url += this.token + "/cliente";

          if (this.senha) {
            this.usuario.senha = this.senha;
          }

        } else {
          url += "cliente";
          this.usuario.senha = this.senha;
        }

        this.$http.post(url, { ...this.usuario, enderecos: null })
          .then(res => {
            this.load = false;

            if ((!this.editar || this.senha) && res && res.data.success) {
              localStorage.setItem('token', res.data.token);
              this.token = res.data.token;

              if (this.origin === '5') {
                localStorage.setItem(this.empresa.dominio_delivery, res.data.token);
              }

              if (!this.editar) {
                this.$helpers.googleTag(this, '4');
              }
            }

            if (this.editar) {
              this.$swal("Dados editados com sucesso!");
            }

            this.buscarUsuario(() => {
              if (this.sacola && this.sacola.produtos.length) {
                this.$router.push(this.url + '/finalizar')

              } else if (this.$route.name !== 'Perfil') {
                this.$router.push(this.url + '/perfil')
              }
            });

          }, res => {
            this.load = false;
            console.log(res);
            let msg = res.data && res.data.msg ? res.data.msg : 'Erro temporário';
            const tipo = res.data ? res.data.tipo : null

            if (!this.editar && tipo === 1) {
              this.$swal({
                text: msg,
                buttons: ["Não", "Sim"]
              }).then((r) => {
                if (r) {
                  this.$router.push(this.url + '/perfil/esqueci-senha')

                } else {
                  this.step = 3;
                  this.$nextTick(() => {
                    this.$helpers.focusrElement('telefoneCliente');
                  });
                }
              });

            } else {
              this.$swal(msg).then(() => {
                if (tipo === 2) {
                  this.step = 3;
                  this.$nextTick(() => {
                    this.$helpers.focusrElement('cpf');
                  });
                }
              })
            }
          });
      },

      novaConta() {
        this.step = 3;

        if (this.tipoLogin === 3) {
          this.usuario.cpf = this.usuario.email;
          this.usuario.email = '';
          this.$helpers.focusrElement('telefoneCliente');

        } else if (!this.isEmail) {
          this.usuario.telefone = this.usuario.email;
          this.$helpers.focusrElement('nomeCliente');

        } else {
          this.$helpers.focusrElement('telefoneCliente');
        }
      },

      recuperarSenha() {
        sessionStorage.setItem('recuperarSenha', JSON.stringify(this.usuario));
        this.$router.push(this.url + '/perfil/esqueci-senha');
      },

      mostrarSenha(id) {
        const input = document.getElementById(id);

        if (input) {
          input.type = input.type === "password" ? "text" : "password";
        }

        this.$helpers.focusrElement(id);
      },

      alterarCpf() {
        this.usuario.cpf = "";
        this.cpf_mascarado = null;
        this.$nextTick(() => {
          this.$helpers.focusrElement('cpf');
        })
      }
    },

    created() {
      document.body.classList.remove("modal-open");

      if (this.token) {
        this.editar = true;
        this.step = 3;
        this.buscarUsuario(() => {
          if (this.$route.hash === '#senha') {
            this.trocarSenha = true;
            this.$nextTick(() => {
              this.$swal("Por favor cadastre uma nova senha").then(() => {
                this.$helpers.focusrElement('novaSenha');
              });
            });

          } else {
            this.$helpers.focusrElement('telefoneCliente');
          }
        });

      } else {
        this.$helpers.focusrElement('telefoneLogin');
      }
    },

    mounted() {
      window.scrollTo(0,0);
      this.editarTelefone = this.$route.name === 'Telefone';
      this.url = this.origin === '5' ? '/' + this.$store.state.empresa.dominio_delivery : '';
      this.cadastro_completo = this.empresa.json_config.cadastro_completo;
      this.cpf_pedido = this.empresa.json_config.cpf_pedido;
      this.bloquear_nome = this.editar && this.empresa.json_config.bloquear_nome;
      this.login_senha = this.empresa.json_config.login_senha === '1';
      this.menus[2].active = this.cpf_pedido;
    },

    computed: {
      unidades() {
        return this.$store.state.unidades;
      },

      empresa() {
        return this.$store.state.empresa
      },

      sacola() {
        return this.$store.state.sacola
      },

      dataUser() {
        return this.$store.state.dataUser
      }
    },

    filters: {
      tipo_cliente(tipo) {
        switch (tipo) {
          case '1':
            return 'Site/App';
          case '3':
            return 'WhatsApp';
          case '5':
            return 'UaiRango';
        }
      },

      cpf(value) {
        if (!value) return '';
        value = value.toString().replace(/\D/g, '');
        if (value.length !== 11) return value;
        return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      }
    }
  }
</script>

<style scoped>
  .p-bottom {
    padding-bottom: 45px;
  }

  .user {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    border-top: 1px solid #E9ECEF;
  }

  .card-user {
    padding: 14px 14px 8px;
  }
</style>
